import { Link } from '@tanstack/react-router';
import { ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/**
 * The page-level rendering of a `forbidden` failure. Reached from the router's
 * default error component, so any query denied with a 403 lands here rather
 * than on a per-page "failed to load" string.
 */
export function AccessDenied() {
  const { t } = useTranslation();

  return (
    <div className='flex flex-1 flex-col items-center justify-center gap-4 p-8 text-center'>
      <div className='flex size-12 items-center justify-center rounded-full bg-muted'>
        <ShieldAlert className='size-6 text-muted-foreground' />
      </div>
      <div className='space-y-1.5'>
        <h2 className='text-lg font-semibold'>{t('accessDenied.title')}</h2>
        <p className='mx-auto max-w-md text-sm text-muted-foreground'>{t('accessDenied.description')}</p>
      </div>
      <Button asChild variant='outline'>
        <Link to='/'>{t('accessDenied.back')}</Link>
      </Button>
    </div>
  );
}
